import {
    Box,
    Button,
    CardActions,
    CardContent,
    Container,
    Drawer,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import { FileUploaderSingle } from '../../components/upload';
import DropzoneWrapper from '../../styles/react-dropzone';
import { convertURLtoFile } from '../../utils/convertURLtoFile';

const DialogGift = (props) => {
    const { giftID, show, setShow, setReload } = props;
    const [files, setFiles] = useState([]);
    const [list, setList] = useState(null);
    const [gift, setGift] = useState(null);
    const defaultValues = {
        category: gift?.category || '',
        title: gift?.title || '',
        price: gift?.price || '',
        offset: gift?.offset || '',
        desc: gift?.descript || ''
    }
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();

    useEffect(() => {
        if(show) {
            giftID ? getGift(giftID) : setGift(null);
        } else {
            reset(defaultValues);
            setFiles([]);
        }
    }, [show])

    useEffect(() => {
        console.log('gift', gift);

        if (gift?.icon) {
            convertURLtoFile(gift.icon, setFiles);
        }
        reset(defaultValues);        
    }, [gift])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.get('/giftshopcategory');
                setList(response.data.list);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, []);

    const getGift = async (id) => {
        try {
            const response = await apiService.get(`/giftshop/${id}`);
            setGift(response.data.data);
        } catch (error) {
            console.error(error);
            toast.error('존재하지 않는 상품권입니다.', {
                position: "top-center"
            });
            setShow(false);
        }
    }

    const onSubmit = async (data, e) => {
        e.preventDefault();

        if(files.length == 0) {
            toast.error('No file selection', {
                position: "top-center"
            })
            return false;
        }

        const [file] = files;
        const formData = new FormData()

        formData.append('category', data.category);
        formData.append('title', data.title);
        formData.append('price', data.price);
        formData.append('offset', data.offset);
        formData.append('desc', data.desc);
        formData.append('file', file);

        try {
            await apiService.postFormData('/giftshop', formData);
            toast.success('등록 되었습니다.');
            setReload(reload => reload + 1);
        } catch (error) {
            toast.error('등록이 실패했습니다.');
        } finally {
            setShow(false);
        }
    }

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setShow(open);
    };

    return (
        <Drawer anchor='right' open={show} onClose={toggleDrawer(false)}>
            <Container sx={{width: '800px', pt: 8, px: '2rem !important'}}>
                <form onSubmit={handleSubmit(onSubmit)} id="giftform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                상품권 등록
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id='category'>카테고리</InputLabel>
                                    <Controller
                                        name='category'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='카테고리'
                                                value={value}
                                                onChange={onChange}
                                                labelId='category'
                                                error={Boolean(errors.category)}
                                            >
                                                {
                                                    list.map((item, index) => 
                                                        <MenuItem key={index} value={item.id}>{item.title}</MenuItem>
                                                    )
                                                }
                                            </Select>
                                        )}
                                    />
                                    {errors.category && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-category'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                fullWidth
                                                label='타이틀'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='타이틀을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                aria-describedby='validation-async-title'
                                            />
                                        )}
                                    />
                                    {errors.title && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='price'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                fullWidth
                                                label='가격'
                                                id='price'
                                                onChange={onChange}
                                                placeholder='가격을 입력해주세요'
                                                error={Boolean(errors.price)}
                                                aria-describedby='validation-async-price'
                                            />
                                        )}
                                    />
                                    {errors.price && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-price'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='offset'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                fullWidth
                                                label='포인트 차감액'
                                                id='offset'
                                                onChange={onChange}
                                                placeholder='차감액을 입력해주세요'
                                                error={Boolean(errors.offset)}
                                                aria-describedby='validation-async-offset'
                                            />
                                        )}
                                    />
                                    {errors.offset && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-offset'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='desc'
                                        control={control}
                                        rules={{ required: false }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                fullWidth
                                                label='설명'
                                                id='desc'
                                                onChange={onChange}
                                                placeholder='설명을 입력해주세요'
                                                aria-describedby='validation-async-desc'
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <DropzoneWrapper>
                                    <FileUploaderSingle files={files} setFiles={setFiles} />
                                </DropzoneWrapper>
                            </Grid>

                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="giftform" variant='contained'> 등록 </Button>
                    <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
                        취소
                    </Button>
                </CardActions>
            </Container>
        </Drawer>        
    )
}

export default DialogGift